import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Register from './pages/register';
import SignIn from './pages/signin';
import RegisterTypes from './pages/register-types';
import WaitingPage from './pages/waiting-page';
import Confirm from './pages/confirm';
import RequestEditLink from './pages/request-edit-link';
import RequestBadge from './pages/request-badge';
import EditLinkSent from './pages/edit-link-sent';
import BadgeSent from './pages/badge-sent';

const AppRoutes = () => (
  <>
    <Routes>
      {process.env.REACT_APP_COMING_SOON ? (
        <Route path="*" element={<WaitingPage />} />
      ) : (
        <>
          <Route path="/" element={<SignIn />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/register-types" element={<RegisterTypes />} />
          <Route path="/register/:type" element={<Register />} />
          <Route path="/register/:type/edit/:token" element={<Register />} />
          <Route path="/modifier-inscription" element={<RequestEditLink />} />
          <Route path="/modifier-inscription/confirmation" element={<EditLinkSent />} />
          <Route path="/recuperer-badge" element={<RequestBadge />} />
          <Route path="/recuperer-badge/confirmation" element={<BadgeSent />} />
          <Route path="/confirm/:userId" element={<Confirm />} />
          <Route path="/confrim/:userId" element={<Confirm />} />
          <Route path='*' element={<SignIn />} />
        </>
      )}
    </Routes>
  </>
);

export default AppRoutes;
